import { render, staticRenderFns } from "./order-change.vue?vue&type=template&id=0f1ec56c&"
import script from "./order-change.vue?vue&type=script&lang=js&"
export * from "./order-change.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports